import actions from '../../store/actions'
import { useState } from 'react'
import { mutations } from '../../resources'
import { generateError } from '../../helpers/errors'
import { useDispatch } from '../redux'
import { NewsModel } from '../../models'
import { ShareNewsRequest } from '../../resources/news/types'

export const useNewsUpdate = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const shareNews = (id: number, payload: ShareNewsRequest): Promise<NewsModel> => {
        setInProgress(true)
        return mutations
            .updateNews({ ...payload, id: id })
            .then((response) => {
                dispatch(actions.setNews(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                setInProgress(false)
                throw generateError(error)
            })
    }

    return {
        shareNews,
        inProgress,
    }
}
